import styled from "styled-components";
import Colors from "../../../themes/Colors";

export const UserFormContainer = styled.div`
  width: 100%;
  padding: 0;
`;

export const UserFormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 15px;
  }
`;

export const UserFormSingleRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;

export const UserFormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  padding-top: 25px;
  border-top: 1px solid #e9ecef;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const UserFormGroup = styled.div`
  margin-bottom: 0;
  position: relative;
  min-height: 80px;

  input {
    min-height: 45px !important;
    font-size: 16px !important;
    padding: 12px 15px !important;
    border: 2px solid #ddd !important;
    border-radius: 6px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    transition: border-color 0.3s ease !important;

    &.error {
      border-color: #dc3545 !important;
      margin-left: 5px !important;
    }
  }

  select {
    min-height: 45px !important;
    font-size: 16px !important;
    padding: 12px 45px 12px 15px !important;
    border: 2px solid #ddd !important;
    border-radius: 6px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    background-position: right 15px center !important;
    background-size: 12px !important;
    transition: border-color 0.3s ease !important;
    appearance: none !important;
    background-image: url("data:image/svg+xml;charset=US-ASCII,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'><path fill='%23666' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>") !important;
    background-repeat: no-repeat !important;

    &.error {
      border-color: #dc3545 !important;
    }
  }

  label {
    font-size: 16px !important;
    font-weight: 600 !important;
    margin-bottom: 8px !important;
    color: ${Colors.primaryPrimera} !important;
    display: block !important;
  }
`;
